import { ReactNode } from 'react';

interface IParagraph {
  content?: Array<string>;
  children?: ReactNode;
  bottomMargin?: boolean;
  className?: string;
}

export const Paragraph = ({
  content,
  children,
  bottomMargin = true,
  className = '',
}: IParagraph): JSX.Element => {
  let paraComponent;

  if (content && content.length)
    paraComponent = content.map((ele: string, index: number) => {
      let paraMarginBottom = false;
      if (
        index != content.length - 1 ||
        (index == content.length - 1 && bottomMargin)
      )
        paraMarginBottom = true;
      return (
        <p
          key={index}
          className={`font-medium text-font-200 sm:text-s-14 sm:mb-7 ${
            paraMarginBottom ? 'mb-6' : ''
          } ${className}`}
        >
          {ele}
        </p>
      );
    });
  return (
    <>
      {paraComponent ? paraComponent : null}
      {children ? (
        <p
          className={`font-medium text-font-200 ${
            bottomMargin ? 'mb-6' : ''
          } ${className} sm:text-s-14 sm:mb-7`}
        >
          {children}
        </p>
      ) : null}
    </>
  );
};
